function NonAuthLayout({ children }) {
  return <div>{children}</div>
}

export default NonAuthLayout
